// Small presentational helpers shared by the admin CRUD modals (Header-,
// Sprachen-, Drucken-Einstellungen-, Benutzer-, Werkzeugleisten-,
// Produktstamm-, Farben-, Kontextmenü-Verwaltung) — previously each modal
// defined its own byte-identical copy.
function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('de-CH', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function activeBadge(value) {
  return value ? '<span class="admin-pill admin-pill--active">aktiv</span>' : '<span class="admin-pill">inaktiv</span>';
}

export {
  formatDate,
  activeBadge
};
